export default __webpack_public_path__ + "static/media/dole-lemonade-products-master-desktop@3x.742c6192.png";